import React, { useEffect, useState } from 'react';
import CommonFunctions from '@common/util/functions.common';
import { Td, TdItem } from './Td';
import Check from './Check';
import './styles.css';
import IntlMessage from "../../../../../helpers/intlMessage";

function Table ({ item }) {
  const [cabecalho, setCabecalho] = useState({});
  const [lista, setLista] = useState([]);

  useEffect(() => {
    const [itemCabecalho] = item;
    const itemCabecalhoFormatado = {
      ...itemCabecalho,
      dataNascFormatada: CommonFunctions.formatDateToAge(
        itemCabecalho.dataNascimento
      )
    };
    setCabecalho(itemCabecalhoFormatado);
    setLista(item);
  }, [item]);

  return (
    <table
      style={{ border: '1px solid #eee', width: '100%', marginBottom: '15px' }}
    >
      <tbody>
        <tr style={{ borderTop: '1px solid #eee' }}>
          <Td title={<IntlMessage id = "dashboards.reports.medicalRecordRGHC"/>} value={cabecalho.prontuario} />
          <td
          colSpan={'1'}
          style={{
            border: '#eee solid 1px',
            fontSize: '12px',
            verticalAlign: 'center',
            padding: '4px 12px',
          }}
        >
          <div>
            <strong><IntlMessage id = "dashboards.general.pacient"/></strong>
            <span style={{ marginLeft: '5px' }}>{cabecalho.paciente}</span>
            {cabecalho.pacienteNomeSocial && <div><strong><IntlMessage id = "dashboards.reports.socialName"/></strong>
              <span style={{ marginLeft: '5px' }}>{cabecalho.pacienteNomeSocial}</span></div>}
          </div>
        </td>
          <Td title={<IntlMessage id = "dashboards.reports.yearsOld"/>} value={cabecalho.dataNascFormatada} />
          <Td title={<IntlMessage id = "dashboards.general.healthInsurance"/>} value={cabecalho.convenio} />
        </tr>
        <tr style={{ borderBottom: '1px solid #eee' }}>
          <Td>
            <TdItem title={<IntlMessage id = "dashboards.general.examNumber"/>} value={cabecalho.exame} />
            <TdItem title={<IntlMessage id = "dashboards.examDetail.block"/>} value={cabecalho.bloco} />
          </Td>
          <Td title={<IntlMessage id = "dashboards.examDetail.table.exam"/>} value={cabecalho.nomeExame} />
          <Td title={<IntlMessage id = "dashboards.general.externalExamNo"/>} value={cabecalho.nrExameAnterior} />
          <Td title={<IntlMessage id = "dashboards.general.report"/>} value={cabecalho.laudo} />
        </tr>

        {lista.map((item, i) => (
          <tr key={i}>
            <td colSpan='4' style={{ padding: '0' }}>
              <table style={{ width: '100%', marginBottom: '7px' }}>
                <tbody>
                  <tr style={{ border: 0 }}>
                    <Td>
                      <TdItem title={<IntlMessage id = "dashboards.examDetail.blade"/>} value={item.lamina} />
                      <TdItem title={<IntlMessage id = "dashboards.reports.antibodies"/>} value={item.anticorpos} />
                    </Td>
                    <Td>
                      <TdItem
                        title={<IntlMessage id = "dashboards.taskControl.pathologistDoctor"/>}
                        value={item.responsavel}
                      />
                      <TdItem title={<IntlMessage id = "dashboards.taskControl.status"/>} value={item.finalizacao} />
                    </Td>
                    <Td title={<IntlMessage id = "dashboards.taskControl.material"/>} value={item.material} />
                    <Td>
                      <TdItem title={<IntlMessage id = "dashboards.taskControl.species"/>} value={item.especie} />
                      <TdItem
                        title={<IntlMessage id = "general.requestsPanel.date"/>}
                        value={CommonFunctions.formatDate(item.data)}
                      />
                    </Td>
                  </tr>
                  <tr style={{ border: 0 }}>
                    <Td>
                      <Check text={<IntlMessage id = "dashboards.reports.inconclusive"/>} />
                    </Td>
                    <Td>
                      <Check text={<IntlMessage id = "dashboards.reports.negative"/>} />
                    </Td>
                    <Td>
                      <Check text={<IntlMessage id = "dashboards.reports.positive"/>} />
                    </Td>
                    <td style={{ borderBottom: 'solid #333 1px' }}></td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default Table;



// WEBPACK FOOTER //
// ./src/pages/controleTarefas/Imuno/Impressao/Table/index.js